<template>
  <div class="question pr">
    <img class="bg" id="bg" :src="bgUrl" @load="onLoadImg" />
    <div class="question-info" v-show="infoStyle.top" :style="infoStyle">
      <div class="question-head x-f">
        <div class="question-item x-end">
          <div class="item-key">提问人：</div>
          <div class="item-value">{{ info.uname || info.userName }}</div>
        </div>
        <div class="question-item x-end">
          <div class="item-key">提问老师：</div>
          <div class="item-value">{{ info.teacher }}</div>
        </div>
      </div>
      <div class="x-start question-container">
        <div class="item-key">问题：</div>
        <div class="item-main">{{ info.query }}</div>
      </div>
    </div>
    <div class="last-question" @click="lastMessage">
      <div class="question-button">下一个问题</div>
    </div>
    <div class="fullscreen" @click="toggleFullscreen">
      <div class="iconfont icon-quanping" :class="{'icon-tuichuquanping': isFullscreen}"></div>
    </div>
  </div>
</template>

<script>
import { queryInfList, activityInf, ossinf, activityUserInfList } from "@/api/index";
const viewId = 'question';
export default {
  name: viewId,
  data() {
    return {
      info: {
        userName: "",
        teacher: "",
        query: "",
      },
      infoStyle: {
        "top": "0px",
      },
      routerItem: {}, // 路由参数
      messageList: [], // 消息列表
      messageIndex: 0, // 消息索引
      messageParams: {
        pageNum: 1,
        pageSize: 1,
        activityId: "",
        isAudit: "Y",
        isIdAsc: true,
      },
      isFullscreen: false, // 全屏状态
      keydownTimer: null, // 防抖定时器
      bgUrl: require("@/assets/question/bg.png"), // 背景图 URL
    };
  },
  mounted() {
    let search = window.location.search;
    let searchParams = {};
    if (search) {
        let searchList = search.replace("?", "").split("&");
        searchList.forEach(param => {
            let [key, value] = param.split("=");
            searchParams[key] = decodeURIComponent(value);
        });
    }
    this.routerItem = searchParams ? searchParams : false;
    if (this.routerItem && this.routerItem.activityId) {
      this.messageParams.activityId = this.routerItem.activityId; // 设置活动 ID
      this.queryInfList(); // 查询信息列表
      this.activityInf(); // 获取当前场次信息
    }
    window.addEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    handleKeyDown(event) {
      if (this.keydownTimer) {
        clearTimeout(this.keydownTimer); // 清除之前的定时器
      }
      this.keydownTimer = setTimeout(() => {
        if (event.key === "ArrowRight") {
          this.lastMessage(); // 右箭头键切换到下一个问题
        } else if (event.key === "ArrowLeft") {
          if (this.messageParams.pageNum) {
            this.messageParams.pageNum -= 1; // 左箭头键回退到上一页
            if (this.messageParams.pageNum < 1) {
              this.messageParams.pageNum = 1; // 确保页码不小于 1
            }
            this.queryInfList(); // 查询上一页数据
          }
        } else if (event.key === "f" || event.key === "F") {
          this.toggleFullscreen(); // 按 F 键切换全屏
        }
      }, 300); // 设置防抖延时为 300 毫秒
    },
    onLoadImg() {
      // 图片加载完成后的处理逻辑
      let height = document.getElementById("bg").offsetHeight;
      try {
        this.infoStyle.top = height * 0.21 + "px";
      } catch(e) {
        this.infoStyle.top = 0;
      }
    },
    queryInfList() {
      // 查询提问列表
      queryInfList(this.messageParams).then((res) => {
        console.log("查询信息列表成功：", res);
        if (res.code === 200) {
          let data = res.rows || [];
          this.messageList = data;
          if (data && data.length > 0) {
            let item = data[0];
             // item.userName = "";
            this.info = data[0]; // 取第一条数据
            // this.activityUserInfList();
          } else {
            this.messageParams.pageNum -= 1; // 如果没有数据，回退页码
            this.$message.error("暂无更多问题"); // 提示已到最后一个问题
          }
        } else {
          this.$message.error(res.msg);
        }
      })
      .catch((error) => {
        console.error("查询信息列表失败：", error);
        this.$message.error("查询信息列表失败，请稍后重试。");
      });
    },
    lastMessage() {
      let index = this.messageIndex + 1;
      let info = this.messageList[index];
      if (info) {
        this.info = info; // 更新信息
        this.messageIndex = index; // 更新索引
      } else {
        this.messageParams.pageNum += 1; // 更新页码
        this.queryInfList(); // 查询下一页数据
        this.messageIndex = 0; // 重置索引
      }
    },
    toggleFullscreen() {
      const elem = document.documentElement;
      this.isFullscreen = !this.isFullscreen;
      if (!document.fullscreenElement) {
          elem.requestFullscreen().catch(err => {
              console.error(`全屏失败: ${err.message}`);
          });
      } else {
          document.exitFullscreen().catch(err => {
              console.error(`退出全屏失败: ${err.message}`);
          });
      }
    },
    activityInf() {
      activityInf(this.routerItem.activityId)
      .then(res => {
        let rows = res.data || {};
        let { qyBgImg } = rows;
        if (qyBgImg && qyBgImg) {
            ossinf(qyBgImg)
            .then(res => {
                if (res.data && res.data.url) {
                    this.bgUrl = res.data.url.replace("http://1.12.248.176:9000/ruoyi-flex", "https://mp.huiyouyizhan.cn/fileDownload");
                } else {
                    this.bgUrl = require("@/assets/question/bg.png");
                }
            }).catch(err => {})
        }
    })
    .catch(err => {
        console.error("获取活动信息失败", err);
    })
    },
    activityUserInfList() {
      activityUserInfList({
        userId: this.info.userId
      })
      .then(res => {
        let list = res.rows;
        if (list && list.length) {
          this.info.userName = list[0]["uname"];
        }
      })
      .catch(err => {
        console.log("err=>", err);
      })
    }
  },
  
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
};
</script>

<style lang="scss" scoped>
.question {
  position: relative;
  height: 100vh;
  width: 100vw;
}
.bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
}
.question-info {
  position: absolute;
  width: 80vw;
  border: 1px solid transparent;
  left: 10%;
  top: 38%;
  height: 34vh;
  border-radius: 36px;
  padding: 20px;
  z-index: 1;
  color: #fff;
  .question-item {
    font-size: 20px;
    .item-value {
      padding-left: 5px;
      font-size: 28px;
      font-weight: bold;
    }
  }
  .question-item + .question-item {
    padding-left: 25px;
  }
  .question-container {
    font-size: 28px;
    padding-top: 10px;
  }
  .item-main {
    flex: 1;
    flex-wrap: wrap;
    font-size: 28px;
  }
}
.last-question {
  position: fixed;
  color: transparent;
  right: 20px;
  font-size: 14px;
  bottom: 20px;
  .question-button {
    padding: 10px;
    // background: #fff;
    border-radius: 8px;
    cursor: pointer;
  }
}
.fullscreen {
  position: fixed;
  left: 20px;
  bottom: 20px;
  color: transparent;
  // background: #fff;
  cursor: pointer;
  .iconfont::before {
    font-size: 28px;
  }
}
</style>